var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',_vm._b({staticClass:"table-widget",attrs:{"headers":_vm.headers,"items":_vm.items,"item-key":'id' + 'variant.id',"items-per-page":1000},scopedSlots:_vm._u([{key:"item.price",fn:function(ref){
var item = ref.item;
return [_c('PriceField',{attrs:{"value":item.price},on:{"set-value":function (v) { return (item.price = v); }}})]}}])},'v-data-table',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }